export const CalloutType = {
	INFO: 'INFO',
	WARNING: 'WARNING',
	ERROR: 'ERROR'
};

export const CalloutVariant = {
	STANDARD: 'STANDARD',
	FILLED: 'FILLED',
	OUTLINED: 'OUTLINED'
};
